import { loadNavigationEpic } from "../redux/loadNavigationEpic";
import { type NavigationNode } from "../types";
import { getStore } from "~/redux/getStore";

export function create(rawData: { navigation: string; flyoutNavigation: string }) {
  getStore().dispatch(loadNavigationEpic(rawData));

  return null;
}

export type NavigationData = {
  root: NavigationNode;
  nodes: Dictionary<NavigationNode>;
};
